/* eslint-disable react/prop-types */
import React, { FunctionComponent } from "react";
import PropTypes from "prop-types";
import Theme from "../../../theme/theme";
import pinkSpinner from "./img/spinner-pink.gif";
import whiteSpinner from "./img/spinner-white.gif";
import { StyledLoader, StyledSpinner, StyledLoaderText } from "./styles";

export interface LoaderProps {
  white?: boolean;
  height?: number;
  text?: string;
  inline?: boolean;
}

export const Loader: FunctionComponent<LoaderProps> = ({
  white,
  height,
  text,
  inline = false,
}) => (
  <Theme>
    <StyledLoader inline={inline}>
      <StyledSpinner
        white={white}
        height={height}
        src={white ? (whiteSpinner as string) : (pinkSpinner as string)}
      />
      {text && <StyledLoaderText white={white}>{text}</StyledLoaderText>}
    </StyledLoader>
  </Theme>
);

Loader.propTypes = {
  white: PropTypes.bool,
  height: PropTypes.number,
  text: PropTypes.string,
};

Loader.defaultProps = {
  white: null,
  height: null,
  text: null,
};

export default Loader;
